export default class SignupForm {
  constructor(formSelector, options) {
    this.socialFormSelector = $(options.socialFormSelector);
    this.formElement = $(formSelector);
    this.googleClientId = options.googleClientId;
    this.registerValidateRoute = options.validateRequestRoute;
    this.isChecking = false;
    this.isValid = false;

    this.initializeGoogleAuth();
    this.bindFormEvents();
  }

  initializeGoogleAuth() {
    $.getScript("https://accounts.google.com/gsi/client?hl=de", () => {
      google.accounts.id.initialize({
        client_id: this.googleClientId,
        callback: (d) => {
          this.socialFormSelector.find('input[name="credential"]').remove();
          $("<input />")
            .attr("type", "hidden")
            .attr("name", "credential")
            .val(d.credential)
            .appendTo(this.socialFormSelector);
          this.socialFormSelector.trigger("submit");
        },
      });
      google.accounts.id.renderButton($("#signup-with-google")[0], {
        type: "standard",
        text: "signup_with",
        size: "large",
        logo_alignment: "left",
      });
    });
  }

  bindFormEvents() {
    this.formElement.find("#login_agb").on("click", (e) => {
      this.formElement.find("#login_agb").parent().removeClass("is-invalid");
    });

    this.formElement.on("submit", (e) => this.handleSubmit(e));
  }

  handleSubmit(e) {
    // If the form has already been validated, let it submit
    if (this.isValid) {
      return true;
    }

    e.preventDefault(); // We prevent default only if it hasn't been validated

    // Remove any previous error indicators
    this.clearValidationErrors();

    // Check for terms and conditions
    if (!this.formElement.find("#login_agb").is(":checked")) {
      this.displayValidationError(
        "Bitte stimme den Nutzungsbedingungen zu und erkenne die Datenschutzerklärung an."
      );
      return;
    }

    // If currently validating
    if (this.isChecking) {
      return;
    }

    // Set isChecking to true to prevent multiple submissions
    this.isChecking = true;

    // AJAX request to validate form data
    $.post(this.registerValidateRoute, this.formElement.serialize())
      .done((response) => {
        this.isValid = true;
        this.formElement.trigger("submit");
      })
      .fail((err) => {
        if (err && err.status == 419) {
          document.location.reload();
        } else if (err && err.responseJSON && err.responseJSON.errors) {
          const { errors } = err.responseJSON;

          this.handleFieldErrors(errors);
        }
      })
      .always(() => {
        this.isChecking = false;
      });

    e.preventDefault();
    return false;
  }

  handleFieldErrors(errors) {
    const reversedKeys = Object.keys(errors).reverse();

    reversedKeys.some((field) => {
      const msgs = errors[field];
      const msg = msgs[0];

      if (field == "email" || field == "mobilenumber") {
        field = "identity";
      }

      const invField = $(`input[name=${field}]`, this.formElement)
        .removeClass("is-valid")
        .addClass("is-invalid")
        .trigger("focus");

      if (invField.attr("name") == "voicecall_phonenumber") {
        invField.parent();
      }

      $("<div />")
        .addClass("errormessage mt-2 mb-2 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative")
        .html(msg)
        .insertAfter(invField);

      // Return true to stop the iteration
      return true;
    });
  }

  displayValidationError(message) {
    this.formElement.find("#login_agb").parent().addClass("is-invalid");
    $("<div />")
      .attr("id", "agb-error")
      .addClass(
        "errormessage mt-3 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
      )
      .html(message)
      .insertAfter(this.formElement.find("#login_agb").parent());
  }

  clearValidationErrors() {
    this.formElement.find(".is-invalid").removeClass("is-invalid");
    this.formElement.find(".errormessage").remove();
  }
}

window.SignupForm = SignupForm;
